<template>
  <div class="wrap">
    <van-nav-bar :title="$t('user.title')" :border="false" />
    <div class="content">
      <div class="userInfo_bar">
        <!-- <VanImage width="50" height="50" :src="getImageUrl(userInfo.userimg)" round>
          <VanImage slot="error" width="50" height="50" :src="require('@/assets/Img/myImg/MyOne.png')" round />
        </VanImage> -->
        <div class="user_name">
          <span>{{ $t('newAdd.account') }}:</span> {{ userInfo.userphone }}
        </div>
        <div class="credit_score">
          <img src="@/assets/new/credit_score.png" alt="">
          <div class="credit">{{ userInfo.credit || 0 }}</div>
          <div class="credit_text">{{ $t('user.creditScore') }}</div>
        </div>
      </div>
      <!-- <div class="btns">
        <div class="btn" @click="toRecharge">{{ $t('topUp') }}</div>
        <div class="btn" @click="toWithdraw">{{ $t('withdraw') }}</div>
      </div> -->
      <div class="items">
        <div class="btn_item" @click="basicClick">{{ $t('user.basicInformation') }}</div>
        <div class="btn_item" @click="walletShow = true">{{ $t('user.payment') }}</div>
        <div class="btn_item" @click="switchLansShow = true;">{{ $t('语言') }}</div>
        <div class="btn_item red" @click="logoutEvent">{{ $t('user.logout') }}</div>
      </div>
    </div>
    <van-overlay :show="walletShow" z-index="10" class="wallet">
      <div class="wallet_cont" @click.stop>
        <van-field v-model="walletNum" required label-width="0" :placeholder="$t('user.inputAmount')" />
        <div class="btns">
          <div class="btn cancel" @click="walletShow = false">{{ $t('user.Button.One') }}</div>
          <div class="btn confirm" @click="walletConfirm">{{ $t('user.Button.Two') }}</div>
        </div>
      </div>
    </van-overlay>
    <van-action-sheet v-model="switchLansShow" :actions="lans" :cancel-text="$t('user.Button.One')"
      :description="$t('切换语言')" close-on-click-action @select="checkLans" />
    <van-popup v-model="popShow" position="bottom" class="pop">
      <div class="pop_sign">
        <div class="sign_title">{{ $t('请签名') }}</div>
        <div class="sign_cont">
          <vue-esign ref="esign" :width="400" :height="200" :isCrop="isCrop" :lineWidth="lineWidth"
            :lineColor="lineColor" />
        </div>
        <div class="sing_btn">
          <div class="_btn" @click="handleReset">{{ $t('重签') }}</div>
          <div class="_btn" @click="handleGenerate">{{ $t('user.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog,Toast, NavBar, Image as VanImage, Icon, Overlay, Field, ActionSheet,Popup } from "vant";
import { getLanguage, setLan, setLanguage, lans } from "../../i18n";
import vueEsign from 'vue-esign'
import { USERS_EDIT } from "@/api"
export default {
  data() {
    return {
      walletShow: false,
      walletNum: '',
      switchLansShow: false,
      lans: lans,
      popShow: false,
      lineWidth: 2,
      lineColor: '#000000',
      resultImg: '',
      isCrop: false,
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Dialog.Component.name]: Dialog.Component,
    VanImage,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    vueEsign,
    [Toast.name]: Toast,
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.submitSign(res)
        this.popShow = false;
      }).catch(err => {
        Toast(this.$t('请签名'))
      })
    },
    async submitSign(sign_pic) {
      Toast.loading();
      try {
        const res = await USERS_EDIT({ sign_pic });
        Toast.clear();
        this.handleReset();
        this.$store.dispatch('getUserInfo');
        this.infoClick();
      } catch (error) {
        Toast.clear();
        Toast(error.msg);
      }
    },
    infoClick() {
      if (this.userInfo.auth_level == 1) {
        return this.handleTo('/question')
      }
      if (this.userInfo.auth_level == 2) {
        return this.handleTo('/baseInfoDetail')
      }
      this.handleTo('/baseInfo')
    },
    basicClick() {
      if (!this.userInfo.sign_pic) return this.popShow = true;
      this.infoClick();
      // this.handleTo('/baseInfoDetail')
    },
    toRecharge() {
      this.$router.push("/new-recharge");
    },
    toWithdraw() {
      this.$router.push('/new-withdraw')
    },
    toService() {
      this.$api.toService();
    },
    handleTo(path) {
      this.$router.push(path)
    },
    walletClick() {
      this.walletShow = true;
    },
    walletConfirm() {
      console.log('walletConnfirm');
      this.walletShow = false;
    },
    logoutEvent() {
      let _this = this;
      Dialog.confirm({
        title: this.$t("user.quit"),
        message: this.$t("user.logoutEvent"),
        cancelButtonText: this.$t("user.Button.One"),
        confirmButtonText: this.$t("user.Button.Two"),
      }).then(() => {
        let pwdState = _this.$cookie.get("the-pwd-state");
        let pwdObj = _this.$cookie.get("the-pwd-obj");
        _this.$cookie.clear();
        _this.$cookie.set("the-pwd-state", pwdState);
        _this.$cookie.set("the-pwd-obj", pwdObj);
        _this.$router.push("/login");
      }).catch(() => { });
    },

    getImageUrl(url) {
      const reg = new RegExp("http");
      if (reg.test(url)) return url;
      return this.verConfig.url + url;
    },
    checkLans(actions, index) {
      if (actions.value === getLanguage()) {
        this.switchLansShow = false;
        return;
      }
      this.$i18n.Locale = actions.value;
      this.changeLanguage(actions.value);
      setLanguage(actions.value);
    },
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@button-border-radius: 20px;
@background: var(--nav-background);
@bg: var(--bg);
@sizeColor: var(--sizeColor);

.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.wrap {
  min-height: calc(100vh - 50rem / 16);
  background: @background;
  background: var(--bgImg) no-repeat;
  background-size: cover;

  .content {
    padding: calc(15rem / 16);

    .userInfo_bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: calc(30rem / 16);
      // background: linear-gradient(180deg, #2752e7, #e43832);
      // background-size: 100% 100%;
      // color: var(--white);
      // border-radius: calc(10rem / 16);
      // padding-top: calc(30rem / 16);

      .user_name {
        padding: calc(5rem / 16) calc(15rem / 16);
        border-radius: calc(15rem / 16);
        font-size: calc(14rem / 16);
        background-color: var(--btnColor);
        color: var(--btnsizeColor);
        margin-bottom: calc(15rem / 16);

        span {
          text-transform: uppercase;
        }
      }

      .credit_score {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #fff;
        position: relative;

        img {
          height: calc(206rem / 16);
          display: block;
          // margin-bottom: calc(10rem / 16);
        }

        .credit {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translateX(-50%);
          font-size: calc(20rem / 16);
          // margin-bottom: calc(5rem / 16);
        }

        .credit_text {
          display: inline-block;
          font-size: 10px;
          position: absolute;
          top: 54%;
          left: 0;
          right: 0;
          text-align: center;
          // transform: translateX(-50%);s
          text-transform: uppercase;
          margin-bottom: calc(5rem / 16);
        }
      }
    }

    .items {
      margin-top: calc(20rem / 16);
      padding: 0 calc(15rem / 16);

      .btn_item {
        background-color: var(--btnColor);
        border-radius: calc(10rem / 16);
        color: var(--btnsizeColor);
        font-size: calc(16rem / 16);
        height: calc(48rem / 16);
        line-height: calc(48rem / 16);
        margin: calc(10rem / 16) 0;
        text-align: center;
        font-weight: bold;
      }

      .red {
        // background: #F7F2F3;
        margin-top: calc(20rem / 16);
        // color: #E76669;
      }
    }

    .btns {
      display: flex;
      column-gap: calc(20rem / 16);

      .btn {
        flex: 1;
        height: calc(45rem / 16);
        margin-top: calc(20rem / 16);
        background: #f96;
        border-radius: calc(10rem / 16);
        color: var(--white);
        font-weight: 300;
        text-align: center;
        line-height: calc(45rem / 16);
      }
    }
  }

  .wallet {
    display: flex;
    align-items: center;
    justify-content: center;

    .wallet_cont {
      min-width: 40%;
      background-color: var(--white);
      border-radius: calc(5rem / 16);
      overflow: hidden;
      padding: calc(10rem / 16);

      /deep/ .van-cell::after {
        transform: scaleY(.5);
        border-bottom: 1px solid #ebedf0;
      }

      .btns {
        padding: calc(15rem / 16) calc(15rem / 16) calc(5rem / 16);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          background-color: #2969ff;
          color: var(--white);
          border-radius: calc(5rem / 16);
          font-size: calc(13rem / 16);
          padding: calc(5rem / 16) calc(10rem / 16);
        }
      }
    }
  }
  .pop {
    border-radius: calc(12rem / 16) calc(12rem / 16) 0 0;
    background-color: var(--white);

    .pop_sign {
      .sign_title {
        padding: calc(16rem / 16) 0;
        text-align: center;
        color: var(--theme);
        font-weight: 700;
      }

      .sign_cont {
        margin: 0 calc(12rem / 16) calc(12rem / 16);
        border: 1px dashed #bbb5b5;
        border-radius: calc(12rem / 16);
        overflow: hidden;
      }

      .sing_btn {
        display: flex;
        padding: 0 calc(12rem / 16) calc(12rem / 16);
        align-items: center;
        justify-content: space-between;

        ._btn {
          display: flex;
          align-items: center;
          font-size: calc(14rem / 16);
          color: var(--white);
          background: var(--nav-background);
          padding: calc(6rem / 16) calc(10rem / 16);
          border-radius: calc(5rem / 16);
        }
      }
    }
  }
}
</style>